import svg from "./scatterplot-training-data-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const ScatterplotTrainingDataIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.dataViz03.main,
);

export default ScatterplotTrainingDataIcon;
